import React, { useState, createRef, useEffect } from 'react';
import './ItemsList.scss';
import Button from '../Button/Button';
import { isMobile, isIos } from '../../static/helper';
import ReCAPTCHA from "react-google-recaptcha";
import { virtualPageView } from '../Analytics/Analytics';


function ItemsList(props) {
  // const [isThanksModalDisplay, setIsThanksModalDisplay] = useState(false);
  const saveButtonCaptchaRef = createRef();

  const onRemoveClick = (item, category) => {
    props.setCategory(category);
    props.setItem(item, null, props.categories[category].category, category);
    props.setResultsDisplay(false);
  }

  const sendRes = async () => {
    if (localStorage.getItem("dpaevfv_teu")) props.setPageSection("oneTime");
    props.setisLoaderActive(true);
    // var res = await props.postData(onCallback);
    saveButtonCaptchaRef.current.execute();

  }

  // const onCallback = (res) => {
  //   if (res === "success") {
  //     props.setisLoaderActive(false);
  //     localStorage.setItem("dpaevfv_teu", true);
  //     if (isMobile() || isIos()) {
  //       props.setPageSection("thanks");
  //     }
  //     else {
  //       setIsThanksModalDisplay(true);
  //     }
  //   }
  // }

  useEffect(() => {
    virtualPageView("https://decadeparade.ynet.co.il/summery", "Summery");
  }, [])

  return (
    <>
      <div className="list-container">
        {
          props.categories.map((category, i) => (
            <div className={`category-container ${category.category}`}>
              <h2 className="category-title">{category.title}</h2>
              {
                props.selectedItems[category.category].map((item, j) => (
                  <div className="item">
                    <div className="remove" onClick={() => onRemoveClick(item, i)}></div>
                    <img src={`${process.env.PUBLIC_URL}/images/items/${category.category}/${item.id}.jpg`} />
                    <div className="desc">
                      {item.singer ?
                        isMobile() || isIos() ?
                          <label className="singer">{item.singer} <span>-</span> <span>{item.name}</span></label>
                          :
                          <>
                            <label className="singer">{item.singer}</label>
                            <label className="title">{item.name}</label>
                          </>
                        : <label className="title">{item.name}</label>
                      }
                      <span className="year">{item.year}</span>
                    </div>
                  </div>
                ))
              }
            </div>
          ))
        }
      </div>
      <ReCAPTCHA ref={saveButtonCaptchaRef} sitekey={"6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"} onChange={props.postData} className="save" size="invisible"/>
      <Button text={"סיימתי להצביע"} onClickHandle={sendRes} class="save" />
    </>
  );
}

export default ItemsList;
